module.exports = __webpack_public_path__ + "static/media/Logo-digitalizadores.4588816e.png";